"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ResultsContainer;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  background: #f5f5f5;\n  padding: 0 24px;\n  width: 100%;\n  z-index: 1000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var ResultsContainerDiv = _styled.default.div(_templateObject());
function ResultsContainer(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(ResultsContainerDiv, {
        children: children
    });
}
